export const apiurl = window.SERVER_DATA.apiurl;
export const authConfig = window.SERVER_DATA.authConfig;